import { RedoOutlined } from '@ant-design/icons';
import { Button, Form, Space, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { Link } from 'react-router-dom';

import { PREFIX } from '@app/constants';
import { SETTINGS_PATH } from '@app/constants/navigation';
import { useAiPromptsSettings } from '@app/pages/AiPromptsSettings/hooks';

import type { FC } from 'react';

import '@app/pages/AiPromptsSettings/styles/AiPromptsSettings.scss';

const { Text } = Typography;

export const AiPromptsSettings: FC = () => {
  const {
    fields,
    form,
    handleFinishForm,
    handleRestoreDefaultPrompt,
    isDataLoading,
    isSaving,
    restoringKey,
  } = useAiPromptsSettings();

  return (
    <div className={`${PREFIX}ai-prompts-settings`}>
      <Form form={form} onFinish={handleFinishForm}>
        <Space direction="vertical" size={36} style={{ width: '100%' }}>
          {fields.map(({ key, title, description }) => (
            <div className="bc-ai-prompts-settings__prompt-field" key={key}>
              <div className="bc-ai-prompts-settings__label-row">
                <Text strong className="bc-ai-prompts-settings__label">
                  {title}
                </Text>
                <Button
                  type="link"
                  size="small"
                  icon={<RedoOutlined />}
                  loading={restoringKey === key}
                  disabled={isDataLoading || restoringKey !== null}
                  onClick={() => handleRestoreDefaultPrompt(key)}
                  data-testid={`${key}-restore-default`}
                >
                  Промпт по умолчанию
                </Button>
              </div>
              {description && (
                <Text
                  type="secondary"
                  className="bc-ai-prompts-settings__description"
                >
                  {description}
                </Text>
              )}
              <Form.Item name={key} className="mg-0">
                <TextArea
                  size="large"
                  rows={6}
                  maxLength={30000}
                  disabled={isDataLoading}
                  data-testid={`${key}-input`}
                />
              </Form.Item>
            </div>
          ))}

          <div className="bc-ai-prompts-settings__buttons">
            <Link to={SETTINGS_PATH}>
              <Button size="large" data-testid="cancel">
                Отменить
              </Button>
            </Link>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={isSaving}
              disabled={isDataLoading || fields.length === 0}
              data-testid="save"
            >
              Сохранить
            </Button>
          </div>
        </Space>
      </Form>
    </div>
  );
};
